import { PropertyIdFilterOption } from "../components/PropertyIdFilter";
import { RentedPropertyCatalog } from "./buildRentedPropertyCatalog";
import { enrichPropertyFilterLabel } from "./rentedPropertyDisplay";
import { KenloPropertyOption } from "./getKenloPropertyOptions";

export function enrichKenloPropertyOptions(
  options: KenloPropertyOption[],
  catalog: RentedPropertyCatalog
): KenloPropertyOption[] {
  return options.map((option) => ({
    ...option,
    label: enrichPropertyFilterLabel(
      option.label,
      catalog.findByKenloPropertyId(option.kenloPropertyId)
    ),
  }));
}

export function enrichPropertyIdFilterOptions(
  options: PropertyIdFilterOption[],
  catalog: RentedPropertyCatalog
): PropertyIdFilterOption[] {
  return options.map((option) => ({
    ...option,
    label: enrichPropertyFilterLabel(
      option.label,
      catalog.findByPropertyId(option.propertyId)
    ),
  }));
}
